export const giveRandomNumber = (min, max) => Math.floor(Math.random() * max) + min;

export const addQuery = (selector, styleStr) => {
  let css = '';
  css += `${selector} {${styleStr}}`;

  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');

  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
}

export const generateBgAdvantage = (idBanner, backgroundImg) => {
  if (idBanner && backgroundImg) {
    const backgroundImgUrl = `url(${backgroundImg})`;

    addQuery(
      `#${idBanner}`,
      `background-image: ${backgroundImgUrl};
       background-size: cover;
       background-repeat: no-repeat;`,
    )
  }
}

